/**
 * Recorrer un listado paginado del catálogo hasta el final (1.3).
 *
 * Los listados con tope devuelven `nextOffset` --`null` cuando no queda
 * nada--. Para las listas CORTAS de las que se sacan conclusiones --los lotes
 * del mes, las mecánicas-- quedarse con la primera página no es un detalle de
 * presentación: una alerta calculada sobre media lista dice "todo en orden"
 * cuando no lo está. Esas se piden enteras.
 *
 * Con un tope de páginas, por si el backend devolviera siempre un
 * `nextOffset`: un bucle sin fin contra el API es peor que una lista corta, y
 * el tope se nota en vez de colgar la pantalla.
 */
import { MAX_LIST_PAGES } from "./limits.ts";

export interface Page {
  readonly nextOffset: number | null;
}

export const collectPages = async <P extends Page>(
  fetchPage: (offset: number) => Promise<P>,
  merge: (pages: readonly P[]) => P,
  maxPages: number = MAX_LIST_PAGES,
): Promise<P> => {
  const pages: P[] = [];
  let offset: number | null = 0;

  while (offset !== null && pages.length < maxPages) {
    const page: P = await fetchPage(offset);
    pages.push(page);
    offset = page.nextOffset;
  }

  return merge(pages);
};
